/**
 * The base URL for the default assets.
 * This file is updated dynamically during the package build process.
 */
export const defaultAssetsUrl = "https://unpkg.com/@workadventure/scripting-api-extra@1.9.12/dist";
